import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HSEPolicy from '../../components/hse-policy/HSEPolicy';
import UpdatesSection from '../../components/feature/UpdatesSection';

export default function HSEPolicyPage() {
  
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section
        className="relative text-white overflow-hidden  h-[400px] flex items-end lg:pb-[70px] pb-0 lg:pl-[140px] pl-[0px] items-center lg:items-end lg:justify-start justify-center text-white"
        style={{
          backgroundImage: `linear-gradient(90deg, #022843 0%, rgba(2, 40, 67, 0) 100%), url('https://res.cloudinary.com/dpkn1ppzj/image/upload/v1770054006/5ac152e6a20ff71e66276e88800c410bf28e8881_zfwrsi.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="relative z-10 px-6 text-center lg:text-left">
          <h1 className="text-3xl lg:text-[50px]  font-medium mb-[10px] text-white leading-tight">Health, Safety, Security, & <br /> Environment (HSSE) Policy</h1>
        </div>
      </section>

      <HSEPolicy />
      <UpdatesSection />
      <Footer />
    </div>
  );
}